export default {
  // ProcedureEvidenceView
  editEvidence: 'Edit Procedure Evidence',
  deleteEvidenceConfirmation: 'Are you sure you want to delete the Procedure Evidence?',
  evidenceDeleted: 'Procedure Evidence deleted.',

  // ProcedureEvidenceForm
  evidenceCreated: 'Procedure Evidence created.',
  evidenceUpdated: 'Procedure Evidence updated.',
}
